import { ActionContext, Module } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';
export interface DownloadCenterStoreState {
  upgradePathPopup: {
    product: any[];
    model: any[];
    currentVersion: any[];
    upgradeToVersion: any[];
  };
}
export default {
  state: {
    upgradePathPopup: {
      product: [],
      model: [],
      currentVersion: [],
      upgradeToVersion: [],
    },
  },
  mutations: {
    setUpgradePathPopupOptions(state, payload) {
      const key = payload.key;
      // @ts-ignore
      state.upgradePathPopup[key] = payload.data;
    },
  },
  actions: {
    getProductFamily(context: ActionContext<DownloadCenterStoreState, RootStoreState>, payload : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `downloads/get-productfamiles?username=${payload}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getApplicableVersion(context: ActionContext<DownloadCenterStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'downloads/get-applicableversions';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    async getApplicableVersionSoftware(context: ActionContext<DownloadCenterStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'downloads/get-applicableversions-software';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    getActivateSoftwareDownload(context: ActionContext<DownloadCenterStoreState, RootStoreState>, payload : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `downloads/activate-software-download?username=${payload}`;
      return ApiServiceWrapper.get(endpoint);
    },
    postActivateSoftwareDownload(context: ActionContext<DownloadCenterStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `downloads/activate-software-download?userName=${payload.username}&choiceID=${payload.choiceID}`;
      return ApiServiceWrapper.post(endpoint, payload);
    },
    downloadSoftware(context: ActionContext<DownloadCenterStoreState, RootStoreState>, payload : any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'downloads/download-software';
      return ApiServiceWrapper.post(endpoint, payload);
    },
  },
  getters: {
    getProductOptions: state => state.upgradePathPopup.product,
    getModelOptions: state => state.upgradePathPopup.model,
    getCurrentVersionOptions: state => state.upgradePathPopup.currentVersion,
    getUpgradeToVersionOptions: state => state.upgradePathPopup.upgradeToVersion,
  },
  namespaced: true,
} as Module<DownloadCenterStoreState, RootStoreState>;
